// extracted by mini-css-extract-plugin
module.exports = {"head":"style_head__14IHO","title":"style_title__1Ygtl","time":"style_time__1rROt","content":"style_content__3QwJx"};